import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    categoryItem: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    dialogButtons: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: 200
    },
    categoryInfoContainer: {
        flexDirection: "column",
        flexShrink: 1,
        gap: 4
    },
    categorySubInfoContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 8
    },
    dialogContentContainer: {
        alignItems: "stretch",
        width: "100%"
    },
    headerTitleContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    },
    categoryItemWrapper: {
        width: "100%"
    },
    dialogContainer: {
        width: "100%",
        minWidth: 300
    },
    listContainer: {
        width: "100%"
    },
    dialogForm: {
        width: "100%"
    },
    container: {
        width: "100%"
    }
});

export default stylesheet;
